module.exports = __webpack_public_path__ + "static/img/weixin2.37f3990c.png";